import { render, staticRenderFns } from "./TextractMappingPage.vue?vue&type=template&id=3bdfe1bb&scoped=true&"
import script from "./TextractMappingPage.vue?vue&type=script&lang=js&"
export * from "./TextractMappingPage.vue?vue&type=script&lang=js&"
import style0 from "./TextractMappingPage.vue?vue&type=style&index=0&id=3bdfe1bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdfe1bb",
  null
  
)

export default component.exports